<template>
  <div :style="{'background-image':'url(https://corpolex-docs.s3.amazonaws.com/BLX_Homepage-Banner.jpeg)'}" class="login-page">
    <b-container>
      <h5 class="logo">
       <img style="width:500px;height:120px" src="../../assets/images/corpolex_isotipo.png"/>
      </h5>
      <Widget style="background-color:#007F7E"  class="mx-auto" title="<h3 class='mt-0'>Ingresa tus credenciales</h3>" customHeader>
       
        <form class="mt" @submit.prevent="logni13">
          <b-alert class="alert-sm" variant="danger" :show="!!errorMessage">
            {{errorMessage}}
          </b-alert>
          <div class="form-group">
            <input class="form-control no-border" ref="username" v-model="usr"
              required type="text" name="username" placeholder="Nombre Usuario" />
          </div>
          <div class="form-group">
            <input class="form-control no-border" ref="password" v-model="pss"
            required type="password" name="password" placeholder="Contraseña" />
          </div>
          <div class="clearfix">
            <div class="btn-toolbar float-right">
              <b-button backgroun-color="" type="submit" size="sm" variant="inverse" click="logni13">INGRESAR</b-button>
            </div>
          </div>
          <div class="row no-gutters mt-3">
            <div class="col">
          </div>
          </div>
        </form>
      </Widget>
    </b-container>
    <footer style="background-color:#ffffff;text-align:center">
      2020 CORPOLEX&copy; Todos los derechos reservados.
    </footer>

  </div>
</template>

<script>
import Widget from '@/components/Widget/Widget';

import 'imports-loader?$=jquery,this=>window!messenger/build/js/messenger'; // eslint-disable-line

const { Messenger } = window;

import axios from "axios";

function initializationMessengerCode() {
  (function () {
    let $,
      FlatMessage,
      spinner_template,
      __hasProp = {}.hasOwnProperty,
      __extends = function (child, parent) {
        for (const key in parent) {
          if (__hasProp.call(parent, key)) child[key] = parent[key];
        }

        function ctor() {
          this.constructor = child;
        }

        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
      };

    $ = jQuery;

    spinner_template = '<div class="messenger-spinner">\n    <span class="messenger-spinner-side messenger-spinner-side-left">\n        <span class="messenger-spinner-fill"></span>\n    </span>\n    <span class="messenger-spinner-side messenger-spinner-side-right">\n        <span class="messenger-spinner-fill"></span>\n    </span>\n</div>';

    FlatMessage = (function (_super) {
      __extends(FlatMessage, _super);

      function FlatMessage() {
        return FlatMessage.__super__.constructor.apply(this, arguments);
      }

      FlatMessage.prototype.template = function (opts) {
        let $message;
        $message = FlatMessage.__super__.template.apply(this, arguments);
        $message.append($(spinner_template));
        return $message;
      };

      return FlatMessage;
    }(Messenger.Message));

    Messenger.themes.air = {
      Message: FlatMessage,
    };
  }).call(window);
};

export default {
  name: 'LoginPage',
  components: { Widget },
  data() {
    return {
      errorMessage: null,
      usr: '',
      pss: '',
      myJson: null,
      locationClasses: 'messenger-fixed messenger-on-top messenger-on-center'
    };
  },

  methods: {
    
    logni13(){

      //axios.post('http://3.232.184.255:8000/corpolex-login', "{no-data}",
     // axios.post('http://localhost:8080/corpolex-login', "{no-data}", 
      axios.post('http://3.232.184.255:8080/corpolex-login', "{no-data}",
      {
          headers: {
          'Content-type': 'application/x-www-form-urlencoded',
          'u_s': this.usr,
          'p_a': this.pss,
        }
      }).then(
        r => 
        {
          this.myJson = r.data;
           //console.log(this.myJson[0].id_company)
            
            if (this.myJson[0].state_code == 'FOUND') {
              
              //SET GLOBAL VALUES 
              window.localStorage.setItem('authenticated', true);
              window.localStorage.setItem('id_company', this.myJson[0].id_company);
              window.localStorage.setItem('name_company', this.myJson[0].name_company);
              window.localStorage.setItem('id_role', this.myJson[0].id_role);
              window.localStorage.setItem('id_user', this.myJson[0].id_user);
              window.localStorage.setItem('logo_path', this.myJson[0].logo_path);

            

              //REDIRECT TO HOME
              this.$router.push('/app/videosPrincipal');
            }
            else{
              this.addErrorNotification();
            }
        }),
        error => {
                console.log(r);
                console.log(error);
            }; 

    },

    //NOTIFICATIONS
      addErrorNotification() {
        Messenger().post({
          message: 'Usuario y/o contraseña incorrecta. Intenta de nuevo.',
          type: 'error',
          showCloseButton: true
        });
    },
  },
  created() {

    initializationMessengerCode();
    
    Messenger.options = {
      extraClasses: this.locationClasses,
      theme: 'air',
    };

    if (window.localStorage.getItem('authenticated') === 'true') {
      this.$router.push('/app/videosPrincipal');
    }
  },
};
</script>

<style src="./Login.scss" lang="scss" scoped />
